/** 기업 포트폴리오 스크린샷 — public/portfolio/corporate/ */

function corporateSrc(filename) {
  return `/portfolio/corporate/${filename}`;
}

function corporateItem(id, title, filename, url) {
  return { id, title, url, src: corporateSrc(filename) };
}

export const CORPORATE_PORTFOLIO_IMAGES = [
  corporateItem("kakao-bank", "카카오뱅크", "kakao-bank.webp", "kakao-bank.dsite"),
  corporateItem("toss-bank", "토스뱅크", "toss-bank.webp", "toss-bank.dsite"),
  corporateItem("game", "게임", "game.webp", "game-studio.dsite"),
  corporateItem("automotive", "자동차", "automotive.webp", "automotive.dsite"),
  corporateItem("hotel", "호텔", "hotel.webp", "hotel.dsite"),
  corporateItem("construction", "건설회사", "construction.webp", "construction.dsite"),
  corporateItem("education", "교육청", "education-office.webp", "education-office.dsite"),
  corporateItem("digital", "디지털솔루션", "digital-solution.webp", "digital-solution.dsite"),
  corporateItem("marketing", "마케팅", "marketing.webp", "marketing-agency.dsite"),
  corporateItem("women-enterprise", "여성기업", "women-enterprise.webp", "women-enterprise.dsite"),
  corporateItem("printing", "인쇄업", "printing.webp", "printing.dsite"),
  corporateItem("manufacturing", "제조업", "manufacturing.webp", "manufacturing.dsite"),
  corporateItem("cosmetics", "화장품", "cosmetics.webp", "cosmetics.dsite"),
];

export const DEFAULT_CORPORATE_IMAGE = CORPORATE_PORTFOLIO_IMAGES[0];
